export const getAPIKeyAndParams = (auth, path) => {
  const definedPath = {
    sites: {
      org: '/orgs/sites.read',
      site: '/orgs/sites.read',
    },
    preRegister: {
      org: '/orgs/devices/provision/cloudAdopt.update',
      site: '/orgs/devices/provision/cloudAdopt.update',
    }
  };

  const { scopeLevel, realm, orgs, sites } = auth;
  const levelId = { realm: realm?.id, org: orgs?.id, site: sites?.id };
  const isStandAloneOrg = !levelId.org || Object.keys(orgs)?.length === 0;
  const apiKey = isStandAloneOrg ? `${definedPath[path][scopeLevel]}` : `/ents${definedPath[path][scopeLevel]}`;
  const placeholder = isStandAloneOrg ? { orgId: levelId.realm } : { entId: levelId.realm, orgId: levelId.org };

  if (scopeLevel === 'site') {
    placeholder.siteId = levelId.site;
  }

  return { apiKey, placeholder };
}